module.exports = __webpack_public_path__ + "img/domain14-icon-4.433ab4fb.webp";